<template>
  <div id="main">
    <split-pane
      v-on:resize="resize"
      :min-percent="10"
      :default-percent="20"
      split="vertical"
    >
      <template slot="paneL">
        <div id="treeDivs">
          <ProOrgTree
            :parentMsg="parentMsg"
            v-on:treeInfo="getTreeInfo"
          ></ProOrgTree>
        </div>
      </template>
      <template slot="paneR">
        <div id="listTables">
          <div class="rightTopButton">
            <el-button
              size="small"
              type="primary"
              icon="el-icon-plus"
              @click="addForm"
              plain
              >新增项目</el-button
            >
          </div>
          <div class="pomRightContent">
            <div class="table">
              <el-table
                :data="tableData"
                border
                stripe
                size="small"
                :header-cell-style="{ background: '#ECF5FF', color: '#606266' }"
                style="width: 100%"
                height="100%"
              >
                <el-table-column
                  type="index"
                  align="center"
                  width="40"
                  label=" "
                >
                </el-table-column>
                <el-table-column
                  prop="name"
                  align="left"
                  header-align="center"
                  show-overflow-tooltip
                  label="项目名称"
                >
                </el-table-column>
                <el-table-column
                  prop="commPerson"
                  align="center"
                  width="100"
                  show-overflow-tooltip
                  label="联系人"
                >
                </el-table-column>
                <el-table-column
                  prop="commPhone"
                  align="center"
                  width="120"
                  label="联系电话"
                >
                </el-table-column>
                <el-table-column
                  prop="addr"
                  align="left"
                  header-align="center"
                  show-overflow-tooltip
                  label="地址"
                >
                </el-table-column>
                <el-table-column
                  fixed="right"
                  label="操作"
                  align="center"
                  width="200"
                >
                  <template slot-scope="scope">
                    <el-tooltip content="关联组织" placement="top">
                      <el-button
                        size="mini"
                        icon="el-icon-share"
                        @click="relation(scope.row)"
                        circle
                        plain
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip content="关联人员" placement="top">
                      <el-button
                        size="mini"
                        icon="el-icon-setting"
                        @click="showSetting(scope.row)"
                        circle
                        plain
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip content="编辑" placement="top">
                      <el-button
                        size="mini"
                        type="primary"
                        icon="el-icon-edit"
                        @click="editForm(scope.row)"
                        circle
                        plain
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip content="删除" placement="top">
                      <el-button
                        size="mini"
                        type="danger"
                        icon="el-icon-delete"
                        @click="showDelAlert(scope.row)"
                        circle
                        plain
                      ></el-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pagination">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[15, 30, 50, 100]"
                :page-size="rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totle"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </template>
    </split-pane>

    <el-dialog
      width="60%"
      title="项目信息"
      :close-on-click-modal="false"
      :visible.sync="dialogFormVisible"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="项目名称"
              :label-width="formLabelWidth"
              prop="name"
            >
              <el-input
                v-model="form.name"
                placeholder="请输入项目组织名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="项目简称"
              :label-width="formLabelWidth"
              prop="shortName"
            >
              <el-input
                v-model="form.shortName"
                placeholder="请输入项目简称"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="项目组织类型"
              :label-width="formLabelWidth"
              prop="proType"
            >
              <el-select
                v-model="form.proType"
                placeholder="请选择项目组织类型"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in poType"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="联系人"
              :label-width="formLabelWidth"
              prop="commPerson"
            >
              <el-input
                v-model="form.commPerson"
                placeholder="请输入联系人"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="联系电话"
              :label-width="formLabelWidth"
              prop="commPhone"
            >
              <el-input
                v-model="form.commPhone"
                placeholder="请输入联系电话"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="排序号"
              :label-width="formLabelWidth"
              prop="orderNo"
            >
              <el-input
                type="number"
                v-model="form.orderNo"
                placeholder="请输入排序号"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="地址"
              :label-width="formLabelWidth"
              prop="addr"
            >
              <el-input v-model="form.addr" placeholder="请输入地址"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!newFormFlag">
            <el-form-item
              label="工程划分编码"
              :label-width="formLabelWidth"
              prop="pCode"
            >
              <el-input
                v-model="form.pCode"
                placeholder="实体项目自动生成"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="是否实体项目"
              :label-width="formLabelWidth"
              prop="engineering"
            >
              <el-switch
                v-model="form.engineering"
                :active-value="1"
                :inactive-value="0"
                @change="switchChange"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveForm('form')" size="medium"
          >确 定</el-button
        >
        <el-button @click="dialogFormVisible = false" size="medium"
          >取 消</el-button
        >
      </div>
    </el-dialog>

    <div class="pomDialogDiv">
      <el-dialog
        :close-on-click-modal="false"
        :visible.sync="dialogSettingVisible"
        width="60%"
        top="5vh"
      >
        <associated-organizations-users :parentMsg="parentMsg2" />
      </el-dialog>
    </div>

    <div class="tre">
      <el-dialog
        title="请选择关联组织"
        :visible.sync="dialogSettingVisible1"
        width="40%"
        top="5vh"
        @close="dialogClose"
      >
        <div class="find">
          <el-input
            placeholder="请输入组织名称查询"
            v-model="filterText"
            class="input-with-select"
            size="small"
            clearable
            @keyup.enter.native="treeFilter"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="treeFilter"
            ></el-button>
          </el-input>
        </div>
        <el-tree
          v-loading="loading"
          element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
          ref="trees"
          class="treeHeight"
          :data="treeData"
          show-checkbox
          node-key="id"
          :props="defaultProps"
          @check-change="getChecked"
          :filter-node-method="filterNode"
          :check-strictly="true"
          :default-expanded-keys="defaultExpandedKeys"
          :default-checked-keys="resourceCheckedKey"
        >
        </el-tree>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogSettingVisible1 = false">取 消</el-button>
          <el-button type="primary" @click="savePeron">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ProOrgTree from "@/components/ProOrgTree";
import AssociatedOrganizationsUsers from "@/components/AssociatedOrganizationsUsers";
import {
  addOrUpdateProOrg,
  checkPartCountByCode,
  deleteProOrg,
  getProOrgList
} from "../api/proOrg";

var validPhone = (rule, value, callback) => {
  const reg = /^[0-9]*$/;
  if (value && !reg.test(value)) {
    callback(new Error("请输入数字联系方式！"));
  } else {
    callback();
  }
};
export default {
  name: "PrjOrganizationManage",
  components: {
    ProOrgTree: ProOrgTree,
    AssociatedOrganizationsUsers: AssociatedOrganizationsUsers
  },
  data() {
    return {
      loading: false,
      defaultExpandedKeys: [],
      resourceCheckedKey: [],
      checkedMenuIds: [],
      arrId: [],
      getId: "",
      node: "",
      treeData: [],
      defaultProps: {
        children: "children",
        label: "label"
      },
      parentId: "",
      newFormFlag: true,
      parentMsg: {
        enumTitle: "项目组织管理",
        refreshTreeFlag: false
      },
      parentMsg2: {
        orgId: ""
      },
      treeInfo: Object,
      dialogFormVisible: false,
      dialogSettingVisible: false,
      dialogSettingVisible1: false,
      formLabelWidth: "120px",
      totle: 0,
      rows: 15,
      currentPage: 1,
      tableData: [],
      poType: [],
      form: {
        name: "",
        proType: "",
        orderNo: "",
        addr: "",
        pCode: "",
        commPhone: "",
        commPerson: "",
        engineering: 1,
        shortName: ""
      },
      rules: {
        name: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
          {
            min: 1,
            max: 128,
            message: "长度在 1 到 128 个字符之间",
            trigger: "blur"
          }
        ],
        proType: [{ required: true, message: "请选择", trigger: "blur" }],
        commPhone: [
          { required: false, trigger: "blur", validator: validPhone } //这里需要用到全局变量
        ]
      },
      url: "",
      filterText: ""
    };
  },
  watch: {
    treeInfo: function(newVal, oldVal) {
      this.currentPage = 1;
      this.parentId = newVal.listenParentId;
      this.getTableData(newVal.listenParentId);
    },
    parentMsg(newVal, oldVal) {
      // this.getTreeData('refresh')
    }
  },
  computed: {},
  methods: {
    //搜索
    treeFilter() {
      this.$refs.trees.filter(this.filterText);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    getTreeData() {
      this.loading = true;
      this.$axios
        .get("/api/admOrg/getAdmOrgTree?orgId&async=0&self=0")
        .then(response => {
          if (response) {
            //回调勾选默认节点
            this.$nextTick(() => {
              this.getListData();
            });
            let mainTree = { id: "-1", label: "安责险信息管理综合服务平台" };
            if (response.data.length <= 0) {
              _this.treeData = [mainTree];
              this.$emit("treeInfo", {
                listenParentId: "-1",
                listenParentName: "暂无"
              });
            } else {
              mainTree.children = response.data;
              let temp = [mainTree];
              // 展开至第一级
              this.defaultExpandedKeys = [temp[0].id];
              this.treeData = temp;
              if (data !== "refresh") {
                this.$emit("treeInfo", {
                  listenParentId: temp[0].id,
                  listenParentName: temp[0].label
                });
              }
            }
          }
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
        });
    },
    savePeron() {
      var formData = new FormData();
      formData.append("proOrgId", this.getId);
      formData.append("admOrgs", JSON.stringify(this.arrId));
      this.$axios
        .post("/api/proOrg/saveProAdmRel", formData)
        .then(response => {
          if (response.data.succeed) {
            this.$message({
              message: "保存成功",
              showClose: true,
              type: "success"
            });
            this.dialogSettingVisible1 = false;
          }
        })
        .catch(error => {
          this.$message({
            message: "保存失败",
            showClose: true,
            type: "error"
          });
        });
    },
    getChecked() {
      this.arrId = this.$refs.trees.getCheckedKeys();
    },
    //监听对话框关闭事件
    dialogClose() {
      this.checkedMenuIds = [];
    },
    //获取关联列表
    getListData() {
      this.$axios
        .get("/api/proOrg/getProAdmRelList?proOrgId=" + (this.getId || ""))
        .then(response => {
          var list = response.data.data;
          if (list.length > 0) {
            for (var i in list) {
              this.checkedMenuIds.push(list[i].admOrgId);
            }
          }
          this.$refs.trees.setCheckedKeys(this.checkedMenuIds); //获取回调后选中的节点
        })
        .catch(error => {
          this.$message.error("获取默认节点失败！");
        });
    },
    //设置目前勾选的节点
    getRoleMenu() {
      if (this.checkedMenuIds) {
        this.$refs.trees.setCheckedKeys(this.checkedMenuIds);
      }
    },
    handleSizeChange(val) {
      this.rows = val;
      this.currentPage = 1;
      this.getTableData(this.parentId);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData(this.parentId);
    },
    getTreeInfo: function(data) {
      this.treeInfo = data;
    },
    getTableData: function(parentId) {
      var params = {
        parentId: parentId === "-1" ? "" : parentId,
        page: this.currentPage,
        rows: this.rows
      };
      getProOrgList(this.$qs.stringify(params))
        .then(response => {
          this.totle = response.total;
          if (response.rows != null && response.rows.length > 0) {
            this.tableData = response.rows;
          } else {
            this.tableData = [];
          }
        })
        .catch(error => {
          console.log("error:" + error.toString());
        });
    },
    getProjectOrganizationType: function() {
      this.$axios
        .get("/api/category/getCategoryList/key?value=projectOrg")
        .then(response => {
          if (response.data.succeed) {
            this.poType = response.data.data;
          } else {
            console.log("error:" + response.data.msg);
          }
        })
        .catch(error => {
          console.log("error:" + error.toString());
        });
    },
    addForm: function() {
      this.form = {
        parentId: this.parentId === "-1" ? "" : this.parentId,
        engineering: 0
      };
      this.newFormFlag = true;
      this.dialogFormVisible = true;
    },
    editForm: function(form) {
      this.form = Object.assign({}, form);
      this.newFormFlag = false;
      this.dialogFormVisible = true;
    },
    saveForm: function(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          addOrUpdateProOrg(this.newFormFlag, this.$qs.stringify(this.form))
            .then(response => {
              if (response.succeed) {
                this.$message.success("添加成功");
                this.dialogFormVisible = false;
                this.getTableData(this.treeInfo.listenParentId);
                this.parentMsg = {
                  enumTitle: "项目组织管理",
                  refreshTreeFlag: true
                };
              } else {
                this.$message({
                  message: response.msg,
                  showClose: true,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.$message({
                message: error,
                showClose: true,
                type: "error"
              });
            });
        } else {
          return false;
        }
      });
    },
    showDelAlert: function(data) {
      this.$confirm(
        "此操作将永久删除该项目 " + data.name + ", 是否继续?",
        "提示",
        {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        this.delForm(data);
      });
    },
    delForm: function(data) {
      deleteProOrg(this.$qs.stringify({ orgId: data.orgId })).then(response => {
        if (response.succeed) {
          this.getTableData(this.treeInfo.listenParentId);
          this.parentMsg = {
            enumTitle: "项目组织管理",
            refreshTreeFlag: true
          };
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        } else {
          this.$message({
            message: response.msg,
            showClose: true,
            type: "error"
          });
        }
      });
    },
    showSetting(data) {
      this.parentMsg2 = { orgId: data.orgId };
      this.dialogSettingVisible = true;
    },
    relation(data) {
      this.getId = data.orgId;
      this.dialogSettingVisible1 = true;
      // this.checkedMenuIds=[]
      this.getTreeData();
    },
    //是否实体改变
    switchChange(value) {
      if (value === 0 && this.form.pCode) {
        this.form.engineering = 1;
        checkPartCountByCode(
          this.$qs.stringify({ code: this.form.pCode })
        ).then(response => {
          if (response.success) {
            if (response.data > 0) {
              this.$confirm(
                "查询到 " +
                  response.data +
                  " 条下级工程划分数据，此操作会删除，是否继续?",
                "提示",
                {
                  cancelButtonClass: "btn-custom-cancel",
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning"
                }
              ).then(() => {
                this.form.engineering = 0;
              });
            } else {
              this.form.engineering = 0;
            }
          } else {
            this.$message({
              message: response.message,
              showClose: true,
              type: "error"
            });
          }
        });
      }
    }
  },
  mounted() {
    this.getTableData();
    this.getProjectOrganizationType();
  }
};
</script>

<!-- ??? -->
<style scoped>
/deep/ .splitter-pane-resizer.vertical[data-v-212fa2a4] {
  background-color: #e6eef8;
  width: 14px;
}
/deep/ .splitter-pane-resizer[data-v-212fa2a4] {
  opacity: initial;
}
#main {
  height: 100%;
}
#treeDivs {
  width: 99%;
  height: 100%;
  float: left;
  background: white;
  margin-right: 5px;
}
#listTables {
  width: 100%;
  float: right;
  background: white;
  height: 100%;
}

#rightName {
  float: left;
  color: black;
  font-size: 18px;
  font-weight: bold;
  margin-left: 15px;
  margin-top: 15px;
}
.rightTopButton {
  text-align: left;
  margin-top: 10px;
  margin-left: 10px;
  margin-bottom: 10px;
}
.pomRightContent {
  height: 92.5%;
  height: -webkit-calc(100% - 60px);
  height: calc(100% - 60px);
  background: white;
  overflow: auto;
  padding: 0 10px 32px;
  box-sizing: border-box;
}
.pagination {
  height: 32px;
  margin: 0px 0 -32px;
  background: #ecf5ff;
  text-align: left;
}
.table {
  height: 100%;
  background: #d9c666;
}

.pomDialogDiv .el-dialog__body {
  height: 500px;
  padding: 10px 0px;
  margin: 0px 20px;
}
.treeHeight {
  height: 310px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/PrjOrganizationManage.vue